// @flow
import gql from 'graphql-tag';

type TravelerSearch = {
    namespace: 'traveler/search',
    category: 'messages'
};

type TravelerListing = {
    namespace: 'traveler/listing',
    category: 'messages'
};

type StabFeedback = {
    namespace: 'ui-development/shared',
    category: 'stabFeedback'
};

type GXGlobalization = {
    namespace: 'gx/globalization',
    category: 'rebrandingBrandTransition'
};

export type Bundle =
    | TravelerSearch
    | TravelerListing
    | StabFeedback
    | GXGlobalization;

const translationsQuery = gql`
    query LinguaQuery($locale: String, $bundle: Bundle!) {
        translations(locale: $locale, bundle: $bundle) {
            locale
            messages
        }
    }
`;

export default translationsQuery;
